export default "__VITE_ASSET__BmGcsk0V__"